module.exports = __webpack_public_path__ + "img/italian-meatballs.cabc76a1.jpg";